import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import AddCustomerForms from "../AddCustomerForms";

const EditCustomerAndPetForm = () => {
  const { getRouteKey } = useRouter();
  const { customerAddresses } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id")).routeState
    .state as ICustomerProfileState;
  return (
    <div className="p-2">
      <div>
        <AddCustomerForms
          addons={{
            case: "BOOKING_MISSING_DETAILS",
          }}
          addressLayout={customerAddresses?.length === 0 ? "SINGLE" : "MULTI"}
          forUpdate={true}
          layoutFor="BOTH"
        />
      </div>
    </div>
  );
};

export default EditCustomerAndPetForm;
